import React from 'react'
import {
  Button,
  Row,
  Col,
  Table,
  ButtonGroup,
  Modal,
  Form,
} from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons'
import useEmailTemplate from './hooks/useEmailTemplate'
import Trigger from '../../../components/OverlayTrigger'
import { useNavigate } from 'react-router-dom'
import DOMPurify from 'dompurify'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded'
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import ActionMenu from './ActionMenu'
import { AdminsRoutes } from '../../../routes'
import NotificationIconContainer from '../../../components/NotificationIcon/NotificationIconContainer'
export default () => {
  const navigate = useNavigate()
  const {
    emailTemplates,
    loading,
    show,
    setShow,
    setModalData,
    templateData,
    isHidden,
    lang,
    setLang,
    languages,
    type,
    resetEmail
  } = useEmailTemplate()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <div className="section-header-wrap mt-n3 mx-n3">
        <Row>
          <Col>
            <h2 className="title-text">Email Templates</h2>
          </Col>
          <Col>

            <div className='d-flex justify-content-end align-items-center'>

              <Button
                variant='outline-success'
                className='f-right'
                size='sm'
                // hidden={isHidden({ module: { key: 'EmailTemplate', value: 'C' } })}
                onClick={() => {
                  navigate(AdminsRoutes.CreateEmailTemplate)
                  resetEmail()
                }}
              >
                Create
              </Button>
              <Col xs={2} className="text-end">
                <NotificationIconContainer />
              </Col>
            </div>
          </Col>
        </Row>
      </div>
      <div className="TableBg mt-4 pt-1">
        <Table

          striped
          responsive
          hover
          size="sm"
          className="text-center mt-4"
        >
          <thead className="thead-light">
            <tr>
              {['Id', 'Label', 'Type', 'Action'].map(c => (
                <th key={c}>{c}</th>
              ))}
            </tr>
          </thead>

          <tbody id={loading ? 'cover-spin' : ''}>
            {!loading &&
              Object.keys(emailTemplates).map((key, index) => {
                return (
                  <tr key={index}>
                    <td>{emailTemplates[key]?.[0].emailTemplateId}</td>
                    <td>{emailTemplates[key]?.[0].label}</td>
                    <td>{key}</td>
                    <td>
                      <ActionMenu
                        emailTemplates={emailTemplates[key]?.[0]}
                        setModalData={() => setModalData(
                          key,
                          emailTemplates[key]?.[0].templateCode,
                        )}
                        key={key}
                        isHidden={isHidden}
                        navigate={navigate}
                      />
                      {/* <Button
                        variant="btn text-btn"
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                      >
                        <MoreVertRoundedIcon />
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >
                        <MenuItem onClick={handleClose}>
                          <Trigger message="Edit">
                            <Button
                              variant="btn text-btn"
                              hidden={isHidden({
                                module: { key: 'EmailTemplate', value: 'U' },
                              })}
                              onClick={() =>
                                navigate(
                                  `/admin/email-templates/edit/${emailTemplates[key]?.[0].emailTemplateId}`,
                                )
                              }
                            >
                              <BorderColorRoundedIcon />
                              <span className="text">Edit</span>
                            </Button>
                          </Trigger>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                          <Trigger message="View Template">
                            <Button
                              variant="btn text-btn"
                              onClick={() =>
                                setModalData(
                                  key,
                                  emailTemplates[key]?.[0].templateCode,
                                )
                              }
                            >
                              <RemoveRedEyeRoundedIcon />
                              <span className="text">View</span>
                            </Button>
                          </Trigger>
                        </MenuItem>
                      </Menu> */}
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
      </div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        size="lg"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Col>
            <h4>{type}</h4>
          </Col>
          <Col className="m-2">
            <Form.Select
              name="language"
              size="sm"
              className="w-auto float-end"
              value={lang}
              onChange={e => {
                setLang(e.target.value)
              }}
            >
              <option value="EN">English</option>
              {languages?.count &&
                languages?.rows?.map(({ languageName, code }) => {
                  return (
                    code !== 'EN' &&
                    templateData?.[code] !== undefined && (
                      <option key={code} value={code}>
                        {languageName}
                      </option>
                    )
                  )
                })}
            </Form.Select>
          </Col>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(templateData?.[lang]),
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}
